import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        console.error("Uncaught error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="p-8 bg-white dark:bg-slate-900 text-slate-900 dark:text-white min-h-screen font-mono">
                    <h1 className="text-3xl text-red-500 mb-4">Something went wrong.</h1>
                    <h2 className="text-xl text-yellow-500 mb-2">Error: {this.state.error && this.state.error.toString()}</h2>
                    <details className="whitespace-pre-wrap text-sm text-slate-700 dark:text-slate-300">
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </details>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-700"
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
